import React from "react";

const Terms = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow container mx-auto px-8 py-16">
        <div className="flex flex-col gap-8">
          {/* Title and Graphics */}
          <div className="flex justify-between items-center max-md:flex-col max-md:items-start">
            <h1 className="text-[48px] leading-[123%] tracking-[-1.44px] max-md:text-[28px] max-md:tracking-[-1.04px] max-sm:tracking-[-0.96px]">
              Terms of Use
            </h1>
            <div className="grid grid-cols-6 grid-rows-2 gap-0 w-[60%] h-8 max-md:mt-4 max-sm:w-[70%] justify-self-end ml-auto">
              <div className="col-start-1 col-end-2 row-start-2 row-end-3 bg-[#fbcc57]" />
              <div className="col-start-2 col-end-5 row-start-1 row-end-2 bg-[#0965ab]" />
              <div className="col-start-5 col-end-7 row-start-2 row-end-3 bg-[#fd015f]" />
            </div>
          </div>

          <div className="flex gap-12 text-xl max-md:flex-col max-md:text-lg max-sm:text-base mt-20 font-creato">
            <div className="w-1/2 max-md:w-full">
              <strong>Acceptance of Terms</strong>
              <p>
                By accessing and using Openmind's website, you agree to comply
                with and be bound by these Terms of Use. If you do not agree to
                these terms, please do not use the Website.
                <br />
                <br />
                <strong>Use of Website</strong>
                <br />
                You agree to use the Website for lawful purposes only. You are
                prohibited from using the Website to engage in any illegal
                activity, infringe on any third-party rights, or transmit any
                harmful or offensive content.
                <br />
                <br />
                <strong>Intellectual Property</strong>
                <br />
                All content, logos, graphics, and trademarks displayed on the
                Website are the property of Openmind or its licensors. You may
                not reproduce, distribute, or create derivative works from any
                content on the Website without express written permission.
                <br />
                <br />
                <strong>Disclaimer of Warranties</strong>
                <br />
                The Website is provided "as is" and "as available" without any
                warranties, express or implied. We do not guarantee the
                accuracy, completeness, or reliability of any information on the
                Website.
              </p>
            </div>

            <div className="w-1/2 max-md:w-full">
              <strong>Limitation of Liability</strong>
              <br />
              Openmind will not be liable for any damages arising from your use
              of the Website, including direct, indirect, incidental, or
              consequential damages.
              <br />
              <br />
              <strong>Changes to Terms</strong>
              <br />
              We reserve the right to modify these Terms of Use at any time. Any
              changes will be effective immediately upon posting. Your continued
              use of the Website constitutes acceptance of the revised terms.
              <br />
              <br />
              <strong>Governing Law</strong>
              <br />
              These Terms of Use are governed by and construed in accordance
              with the laws of California.
              <br />
              <br />
              <strong>Contact Information</strong>
              <br />
              For any questions about these Terms of Use, please contact us at{" "}
              <a
                href="mailto:hello@openmind.org"
                className="text-blue-500 underline"
              >
                hello@openmind.org
              </a>
              .
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Terms;
